import { MessageCircle } from "lucide-react";

export const RescheduleNotice = () => (
  <div
    className="flex items-start gap-3 bg-[#FBE7C6] border-2 border-[#0A0A0A] rounded-2xl px-4 py-3 mb-6"
    data-testid="reschedule-notice"
  >
    <MessageCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#0A0A0A]" />
    <p className="text-sm text-[#0A0A0A]">
      <span className="font-bold">Need to move a class?</span> Please contact your tutor directly through the chat button to reschedule.
    </p>
  </div>
);
